import {
  Menu,
  MenuItem,
  Typography,
  IconButton,
  Stack,
  Tooltip,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import React from "react";
import { TemplateVariable } from "../../hooks/useTemplateHydration";

// Utility for copying to clipboard
function copyToClipboard(text: string) {
  navigator.clipboard.writeText(text);
}

interface VariablesMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  variables: TemplateVariable[];
}

export const VariablesMenu: React.FC<VariablesMenuProps> = ({
  anchorEl,
  open,
  onClose,
  variables,
}) => (
  <Menu
    anchorEl={anchorEl}
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: { maxHeight: 400, minWidth: 300 },
    }}
  >
    {variables.length === 0 ? (
      <MenuItem disabled>
        <Typography variant="body2">No variables found in template</Typography>
      </MenuItem>
    ) : (
      variables.map((variable) => (
        <MenuItem
          key={variable.name}
          onClick={() => copyToClipboard(`{{${variable.name}}}`)}
        >
          <Stack direction="column" spacing={0.5}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant="body2" sx={{ fontFamily: "monospace" }}>
                {`{{${variable.name}}}`}
              </Typography>
              <IconButton
                size="small"
                tabIndex={-1}
                aria-label={`Copy {{${variable.name}}}`}
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Stack>
            <Tooltip title={variable.value}>
              <Typography variant="caption" noWrap sx={{ maxWidth: 250 }}>
                {variable.value}
              </Typography>
            </Tooltip>
          </Stack>
        </MenuItem>
      ))
    )}
  </Menu>
);
